<template>
  <v-checkbox
      hide-details
      dense
      :readonly="readonly"
      :disabled="disabled"
      :input-value="inputValue"
      :value="value"
      :label="label"
      class="ma-0 pa-0"
      :style="{'max-width': maxWidth}"
      :color="color"
      @click.stop
      :true-value="trueValue"
      :false-value="falseValue"
      @change="eventChange"
  >
    <template v-slot:label>
      <slot></slot>
    </template>
  </v-checkbox>
</template>

<script>
export default {
  name: "CheckBox",
  props: {
    readonly: {
      default: false
    },
    disabled: {
      default: false
    },
    maxWidth: {
      default: '230px'
    },
    inputValue: {
      default: null
    },
    value: {
      default: null
    },
    label: {
      default: ''
    },
    trueValue: {
      default: undefined
    },
    falseValue: {
      default: undefined
    },
    color: {
      default: 'var(--theme-color-one)'
    }
  },
  methods: {
    eventChange (val) {
      this.$emit('onChange', val)
    },
    eventUpdate (val) {
      this.$emit('onUpdate', val)
    }
  }
}
</script>

<style scoped>
</style>
